webpackJsonp([157636680307020],{

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(518);


/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 86);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1);
	
	/***/ }),
	
	/***/ 1:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(3);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(17);
	
	/***/ }),
	
	/***/ 39:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"container":"icon__container___xqcIR alignItems-center display-flex flexDirection-row justifyContent-center pinAll position-absolute","icon":"icon__icon___1MTB1 display-flex fill-smoke--xd"};
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Loader;
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _color = __webpack_require__(6);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _general = __webpack_require__(7);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _sizes = __webpack_require__(8);
	
	var _sizes2 = _interopRequireDefault(_sizes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _color2.default, _general2.default));
	
	function Loader(_ref) {
	  var size = _ref.size,
	      color = _ref.color;
	
	  var smallBorder = size === 'extraSmall' || size === 'small';
	
	  var className = cx('loader', color);
	
	  var style = {
	    width: _sizes2.default[size],
	    height: _sizes2.default[size],
	    borderWidth: smallBorder ? 1 : 2
	  };
	
	  return _react2.default.createElement('div', { className: className, style: style });
	}
	
	Loader.propTypes = {
	  size: _propTypes2.default.oneOf(Object.keys(_sizes2.default)),
	  color: _propTypes2.default.oneOf(Object.keys(_color2.default))
	};
	
	Loader.defaultProps = {
	  size: 'medium',
	  color: 'silver'
	};
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"white":"color__white___1SJ9j borderColor-white borderRightColor-transparent","smoke":"color__smoke___35Of1 borderColor-smoke borderRightColor-transparent","darkSmoke":"color__darkSmoke___j493w borderColor-smoke--d borderRightColor-transparent","silver":"color__silver___2GAUx borderColor-silver borderRightColor-transparent","blue":"color__blue___3N6dr borderColor-blue borderRightColor-transparent"};
	
	/***/ }),
	
	/***/ 7:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"general__loader___2CseQ animation-spin borderRadius-circle borderStyle-solid display-block transitionDuration-m transitionProperty-opacity transitionTimingFunction-ease-in-out"};
	
	/***/ }),
	
	/***/ 8:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loaderSize = {
	  extraLarge: 22,
	  large: 14,
	  medium: 14,
	  small: 8,
	  extraSmall: 6
	};
	
	exports.default = loaderSize;
	
	/***/ }),
	
	/***/ 86:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;
	
	/***/ }),
	
	/***/ 87:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Avatar;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _Loader = __webpack_require__(5);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Image = __webpack_require__(88);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _User = __webpack_require__(89);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _border = __webpack_require__(90);
	
	var _border2 = _interopRequireDefault(_border);
	
	var _general = __webpack_require__(91);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _shape = __webpack_require__(92);
	
	var _shape2 = _interopRequireDefault(_shape);
	
	var _size = __webpack_require__(93);
	
	var _size2 = _interopRequireDefault(_size);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var avatarBorders = Object.keys(_border2.default);
	var avatarSizes = Object.keys(_size2.default);
	
	var styles = _extends({}, _border2.default, _general2.default, _shape2.default, _size2.default);
	
	var imagePlaceholder = {
	  person: _react2.default.createElement(_User2.default, null),
	  picture: _react2.default.createElement(_Image2.default, null)
	};
	
	/**
	 * Avatars display an image if the user has uploaded one but if not, initials
	 * are shown instead. The background color is chosen randomly for each user and
	 * set inline with the `color` prop. Additionally, if there are no initials
	 * stored, there are two placeholder icons to choose from.
	 */
	function Avatar(_ref) {
	  var borderColor = _ref.borderColor,
	      boxShadow = _ref.boxShadow,
	      color = _ref.color,
	      defaultImage = _ref.defaultImage,
	      image = _ref.image,
	      initials = _ref.initials,
	      isLoading = _ref.isLoading,
	      shape = _ref.shape,
	      size = _ref.size,
	      teamImage = _ref.teamImage;
	
	  var cx = _bind2.default.bind(styles);
	
	  var emptyAvatarBorder = cx(borderColor, {
	    avatarBorder: borderColor
	  });
	
	  var avatarProps = {
	    className: cx('avatar', [image ? null : emptyAvatarBorder], shape, size, _defineProperty({}, styles.avatarShadow, boxShadow)),
	    title: initials,
	    style: { backgroundColor: color }
	  };
	
	  var imgProps = {
	    className: cx('avatarImg', borderColor, shape, {
	      avatarBorder: borderColor
	    }),
	    style: { backgroundImage: 'url(' + image + ')' }
	  };
	
	  var initialProps = {
	    className: cx('avatarInitials')
	  };
	
	  var teamProps = {
	    className: cx('avatarTeam', 'team--' + size, borderColor, {
	      avatarBorder: borderColor
	    }),
	    style: { backgroundImage: 'url(' + teamImage + ')' }
	  };
	
	  var loaderSize = void 0;
	
	  if (size === 'xl' || size === 'l') {
	    loaderSize = 'extraLarge';
	  } else if (size === 'xs' || size === 'xxs') {
	    loaderSize = 'extraSmall';
	  } else {
	    loaderSize = 'medium';
	  }
	
	  var teamComponent = teamImage ? _react2.default.createElement('div', teamProps) : null;
	  var placeholderComponent = initials ? null : imagePlaceholder[defaultImage];
	  var imageComponent = image ? _react2.default.createElement('div', imgProps) : placeholderComponent;
	
	  return _react2.default.createElement(
	    'div',
	    avatarProps,
	    isLoading ? _react2.default.createElement(
	      'div',
	      { className: styles.loader },
	      _react2.default.createElement(_Loader2.default, { size: loaderSize })
	    ) : _react2.default.createElement(
	      'span',
	      null,
	      imageComponent,
	      _react2.default.createElement(
	        'div',
	        initialProps,
	        initials
	      ),
	      teamComponent
	    )
	  );
	}
	
	Avatar.propTypes = {
	  /** Hex value to be used with `initials` when there's no `image` */
	  borderColor: _propTypes2.default.oneOf(avatarBorders),
	  boxShadow: _propTypes2.default.bool,
	  color: _propTypes2.default.string,
	  defaultImage: _propTypes2.default.oneOf(Object.keys(imagePlaceholder)),
	  /** URL for the user's avatar */
	  image: _propTypes2.default.string,
	  /** Two characters to be used with `color` when there's no `image` */
	  initials: _propTypes2.default.string,
	  isLoading: _propTypes2.default.bool,
	  shape: _propTypes2.default.oneOf(['circle', 'square']).isRequired,
	  size: _propTypes2.default.oneOf(avatarSizes).isRequired,
	  /** URL for the optional team badge */
	  teamImage: _propTypes2.default.string
	};
	
	Avatar.defaultProps = {
	  boxShadow: false,
	  defaultImage: 'picture',
	  initials: '',
	  isLoading: false,
	  shape: 'circle',
	  size: 'm'
	};
	
	/***/ }),
	
	/***/ 88:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Image;
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__(39);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Image() {
	  return _react2.default.createElement(
	    'div',
	    { className: _icon2.default.container },
	    _react2.default.createElement(
	      'svg',
	      {
	        className: _icon2.default.icon,
	        width: '40',
	        height: '36',
	        viewBox: '0 0 40 36'
	      },
	      _react2.default.createElement('path', { d: 'M39.5,1.94A2.08,2.08,0,0,1,40,3.3V32.66A2,2,0,0,1,39.5,34a2,2,0,0,1-1.21.71A128.29,128.29,0,0,1,20,36,128.29,128.29,0,0,1,1.71,34.71,2,2,0,0,1,.5,34,2,2,0,0,1,0,32.66V3.3A2.08,2.08,0,0,1,.5,1.94a1.81,1.81,0,0,1,1.21-.69A130.14,130.14,0,0,1,20,0,129.56,129.56,0,0,1,38.29,1.25,1.81,1.81,0,0,1,39.5,1.94ZM36,29.25V5A126.26,126.26,0,0,0,20.13,4,133.67,133.67,0,0,0,4,5V29.6l3.71.4,16.87-9.48a3,3,0,0,1,1.58-.4,3.16,3.16,0,0,1,2.42,1ZM14.83,15.83A3.86,3.86,0,0,1,12,17a4,4,0,0,1-4-4,4,4,0,0,1,4-4,4,4,0,0,1,4,4A3.86,3.86,0,0,1,14.83,15.83Z' })
	    )
	  );
	}
	
	/***/ }),
	
	/***/ 89:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = User;
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__(39);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function User() {
	  return _react2.default.createElement(
	    'div',
	    { className: _icon2.default.container },
	    _react2.default.createElement(
	      'svg',
	      {
	        className: _icon2.default.icon,
	        width: '40',
	        height: '40',
	        viewBox: '0 0 40 40'
	      },
	      _react2.default.createElement('path', { d: 'M38.8,38.62l-.54.11-.85.17q-.49.11-1.23.22t-1.59.19A130.42,130.42,0,0,1,20,40Q6.92,40,1,38.58A1.49,1.49,0,0,1,.2,38a1.26,1.26,0,0,1-.16-1,10.72,10.72,0,0,1,2.19-4.7,16.81,16.81,0,0,1,4.2-3.45A27.58,27.58,0,0,1,9.6,27.37q1.43-.56,2.23-.91a8.45,8.45,0,0,0,1.72-1A3.29,3.29,0,0,0,14.73,24,4.59,4.59,0,0,0,14,19.74Q8.28,11,11.95,5a10.06,10.06,0,0,1,3.66-3.64A7.89,7.89,0,0,1,20,0a8,8,0,0,1,4.44,1.31A10.47,10.47,0,0,1,28.13,5q3.66,6-2,14.78a5,5,0,0,0-.9,4.27,3.34,3.34,0,0,0,1.65,1.81,24.56,24.56,0,0,0,3.53,1.55q2.28.95,3.13,1.42a16.81,16.81,0,0,1,4.2,3.45A10.72,10.72,0,0,1,40,36.94a1.26,1.26,0,0,1-.16,1,1.49,1.49,0,0,1-.83.63Z' })
	    )
	  );
	}
	
	/***/ }),
	
	/***/ 90:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"white":"border__white___EAfB7 borderColor-white","snow":"border__snow___1PJAy borderColor-snow","smoke":"border__smoke___3ngaW borderColor-smoke","black":"border__black___2dRHl borderColor-black"};
	
	/***/ }),
	
	/***/ 91:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"avatar":"general__avatar___3uXPO position-relative bg-snow--d","avatarBorder":"general__avatarBorder___2sGuz borderStyle-solid","avatarImg":"general__avatarImg___1MHGu backgroundPosition-centerCenter backgroundRepeat-noRepeat backgroundSize-cover position-absolute transitionDuration-l transitionProperty-opacity transitionTimingFunction-ease-in-out","avatarInitials":"general__avatarInitials___iWD44 c-white textAlign-center textTransform-uppercase width-100","avatarTeam":"general__avatarTeam___kygP5 backgroundRepeat-noRepeat backgroundSize-cover borderRadius-circle boxSizing-contentBox position-absolute","team--xl":"general__team--xl___7AAgx","team--l":"general__team--l___1CWmz","team--m":"general__team--m___2D3Cr","team--s":"general__team--s___3E7gf","team--xs":"general__team--xs___21uVW","team--xxs":"general__team--xxs___lQTZS","loader":"general__loader___2S06C pinCenter position-absolute","avatarShadow":"general__avatarShadow___K4oG2"};
	
	/***/ }),
	
	/***/ 92:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"circle":"shape__circle___28iy2 borderRadius-circle","square":"shape__square___2WAsk borderRadius-l"};
	
	/***/ }),
	
	/***/ 93:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"xl":"size__xl___RzYKt fontSize-xxl","l":"size__l___2xqeU fontSize-xxl","m":"size__m___3J0XU fontSize-l","s":"size__s___1SgIa fontSize-m","xs":"size__xs___5hYN4 fontSize-xs","xxs":"size__xxs___2_2Bc fontSize-xxs"};
	
	/***/ })
	
	/******/ });
	//# sourceMappingURL=marvel-ui-avatar.js.map

/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Download;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Download(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ width: 10, height: 10, xmlns: "http://www.w3.org/2000/svg" }, props),
	    _react2.default.createElement("path", {
	      d: "M4.603 9.861c-.12-.087-2.793-2.396-4.5-4.965a.69.69 0 0 1-.035-.66.66.66 0 0 1 .569-.347h2.242c.224-1.406.62-2.934.845-3.316C3.93.208 4.362 0 5 0s1.07.208 1.276.573c.19.33.604 1.91.845 3.316h2.242a.66.66 0 0 1 .57.347.69.69 0 0 1-.035.66c-1.725 2.57-4.38 4.878-4.501 4.965A.688.688 0 0 1 5 10a.688.688 0 0 1-.397-.139z",
	      fill: "#1FB6FF",
	      fillRule: "evenodd"
	    })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 1149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = PlayIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PlayIcon(_ref) {
	  var size = _ref.size;
	
	  return _react2.default.createElement(
	    'svg',
	    { width: size, height: '100%', viewBox: '0 0 16 22' },
	    _react2.default.createElement('path', { d: 'M0 0v22l16-11z', fillRule: 'evenodd' })
	  );
	}
	
	PlayIcon.propTypes = {
	  size: _propTypes2.default.number
	};
	
	PlayIcon.defaultProps = {
	  size: 16
	};
	module.exports = exports['default'];

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = HeadingCopy;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _generalModule = __webpack_require__(1470);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HeadingCopy(_ref) {
	  var title = _ref.title,
	      subheading = _ref.subheading;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', position: 'topBottom', size: 'xl' },
	    _react2.default.createElement(
	      _heading2.default,
	      { tag: 'h1', size: 'xxxxl', weight: 'semibold' },
	      title
	    ),
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        'h2',
	        { className: _generalModule2.default.subheading },
	        subheading
	      )
	    )
	  );
	}
	
	HeadingCopy.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  subheading: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1470:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"subheading":"src-components-modules-HeadingCopy-styles----general-module---subheading---2pq_4 fontSize-l lineHeight-copy breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xxl fontWeight-4 c-slate"};

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _avatar = __webpack_require__(515);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _TrackHover = __webpack_require__(1323);
	
	var _TrackHover2 = _interopRequireDefault(_TrackHover);
	
	var _index = __webpack_require__(1149);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _generalModule = __webpack_require__(1495);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InfoBlock(_ref) {
	  var _cx, _cx2;
	
	  var avatarOneImage = _ref.avatarOneImage,
	      avatarTwoImage = _ref.avatarTwoImage,
	      download = _ref.download,
	      excerpt = _ref.excerpt,
	      labelMessage = _ref.labelMessage,
	      labelLogo = _ref.labelLogo,
	      image = _ref.image,
	      isHovered = _ref.isHovered,
	      isVideoHover = _ref.isVideoHover,
	      url = _ref.url;
	
	  var card = (0, _classnames2.default)(_generalModule2.default.image, (_cx = {}, _cx[_generalModule2.default.withOverlay] = !isVideoHover, _cx));
	
	  var playButtonClass = (0, _classnames2.default)(_generalModule2.default.videoIcon, (_cx2 = {}, _cx2[_generalModule2.default['videoIcon-hover']] = isHovered, _cx2));
	
	  return _react2.default.createElement(
	    _link2.default,
	    { url: url, download: download, target: '_blank', block: true },
	    _react2.default.createElement(
	      'div',
	      { className: card },
	      _react2.default.createElement(_Image2.default, _extends({}, image, { hasShadow: false })),
	      isVideoHover && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { className: playButtonClass }),
	        _react2.default.createElement(
	          'div',
	          { className: _generalModule2.default.playIcon },
	          _react2.default.createElement(_index2.default, null)
	        )
	      ),
	      labelMessage && _react2.default.createElement(
	        'div',
	        { className: _generalModule2.default.label },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'xs' },
	          labelLogo && _react2.default.createElement(
	            'span',
	            { className: _generalModule2.default.logo },
	            labelLogo
	          ),
	          labelMessage
	        )
	      ),
	      avatarOneImage && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _generalModule2.default.avatarWrap },
	          _react2.default.createElement(_avatar2.default, {
	            shape: 'circle',
	            image: avatarOneImage,
	            size: 'xs',
	            borderColor: 'white',
	            boxShadow: true
	          }),
	          avatarTwoImage && _react2.default.createElement(_avatar2.default, {
	            shape: 'circle',
	            image: avatarTwoImage,
	            size: 'xs',
	            borderColor: 'white',
	            boxShadow: true
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.text },
	      _react2.default.createElement(
	        _paragraph2.default,
	        { size: 'm' },
	        excerpt
	      )
	    )
	  );
	}
	InfoBlock.propTypes = {
	  avatarOneImage: _propTypes2.default.object,
	  avatarTwoImage: _propTypes2.default.object,
	  download: _propTypes2.default.bool,
	  excerpt: _propTypes2.default.string,
	  labelMessage: _propTypes2.default.string,
	  labelLogo: _propTypes2.default.node,
	  image: _propTypes2.default.object.isRequired,
	  isHovered: _propTypes2.default.bool,
	  isVideoHover: _propTypes2.default.bool,
	  url: _propTypes2.default.string
	};
	
	InfoBlock.defaultProps = {
	  isVideoHover: false,
	  download: false
	};
	
	exports.default = (0, _TrackHover2.default)(InfoBlock);
	module.exports = exports['default'];

/***/ }),

/***/ 1495:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"src-components-modules-infoBlock-styles----general-module---image---VX1dN position-relative display-flex opacity-1","withOverlay":"src-components-modules-infoBlock-styles----general-module---withOverlay---1zZ6W","playIcon":"src-components-modules-infoBlock-styles----general-module---playIcon---2i2Jk position-absolute fill-white pinCenter","videoIcon":"src-components-modules-infoBlock-styles----general-module---videoIcon---3QH2Y position-absolute pinAll height-100 width-100 opacity-1","videoIcon-hover":"src-components-modules-infoBlock-styles----general-module---videoIcon-hover---3V6lk","text":"src-components-modules-infoBlock-styles----general-module---text---1RcGD paddingTop-s textAlign-left","label":"src-components-modules-infoBlock-styles----general-module---label---3O2rn position-absolute bg-white padding-xxs paddingRight-xxs marginTop-m marginRight-m borderRadius-s fontWeight-5 pinTR","logo":"src-components-modules-infoBlock-styles----general-module---logo---3XF1U marginLeftRight-xxs","avatarWrap":"src-components-modules-infoBlock-styles----general-module---avatarWrap---_ZA1Z position-absolute display-flex pinTL paddingTop-m paddingLeft-m"};

/***/ }),

/***/ 1243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _events2x = __webpack_require__(2686);
	
	var _events2x2 = _interopRequireDefault(_events2x);
	
	var _productUpdates2x = __webpack_require__(2696);
	
	var _productUpdates2x2 = _interopRequireDefault(_productUpdates2x);
	
	var _resources2x = __webpack_require__(2697);
	
	var _resources2x2 = _interopRequireDefault(_resources2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  events: {
	    alt: 'events',
	    src: _events2x2.default
	  },
	  product: {
	    alt: 'product updates',
	    src: _productUpdates2x2.default
	  },
	  guides: {
	    alt: 'assets and guides',
	    src: _resources2x2.default
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 1244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _buzzfeed2x = __webpack_require__(2677);
	
	var _buzzfeed2x2 = _interopRequireDefault(_buzzfeed2x);
	
	var _cabify2x = __webpack_require__(2678);
	
	var _cabify2x2 = _interopRequireDefault(_cabify2x);
	
	var _css2x = __webpack_require__(2680);
	
	var _css2x2 = _interopRequireDefault(_css2x);
	
	var _deliveroo2x = __webpack_require__(2681);
	
	var _deliveroo2x2 = _interopRequireDefault(_deliveroo2x);
	
	var _hudl2x = __webpack_require__(2690);
	
	var _hudl2x2 = _interopRequireDefault(_hudl2x);
	
	var _yieldr2x = __webpack_require__(2707);
	
	var _yieldr2x2 = _interopRequireDefault(_yieldr2x);
	
	var _monzo2x = __webpack_require__(2693);
	
	var _monzo2x2 = _interopRequireDefault(_monzo2x);
	
	var _sketchPads2x = __webpack_require__(2699);
	
	var _sketchPads2x2 = _interopRequireDefault(_sketchPads2x);
	
	var _ebook2x = __webpack_require__(2685);
	
	var _ebook2x2 = _interopRequireDefault(_ebook2x);
	
	var _ebookCollaboration2x = __webpack_require__(2684);
	
	var _ebookCollaboration2x2 = _interopRequireDefault(_ebookCollaboration2x);
	
	var _designSystems2x = __webpack_require__(2682);
	
	var _designSystems2x2 = _interopRequireDefault(_designSystems2x);
	
	var _userTestingFieldGuide2x = __webpack_require__(2700);
	
	var _userTestingFieldGuide2x2 = _interopRequireDefault(_userTestingFieldGuide2x);
	
	var _DownloadBlue = __webpack_require__(1142);
	
	var _DownloadBlue2 = _interopRequireDefault(_DownloadBlue);
	
	var _buzzfeed = __webpack_require__(1529);
	
	var _buzzfeed2 = _interopRequireDefault(_buzzfeed);
	
	var _cabify = __webpack_require__(1530);
	
	var _cabify2 = _interopRequireDefault(_cabify);
	
	var _deliveroo = __webpack_require__(1531);
	
	var _deliveroo2 = _interopRequireDefault(_deliveroo);
	
	var _hudl = __webpack_require__(1532);
	
	var _hudl2 = _interopRequireDefault(_hudl);
	
	var _monzo = __webpack_require__(1533);
	
	var _monzo2 = _interopRequireDefault(_monzo);
	
	var _yieldr = __webpack_require__(1534);
	
	var _yieldr2 = _interopRequireDefault(_yieldr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// note to marketing team: when adding hubspot pages to bits bobs data, prepend the url with /resources/ -- the ones below without this are not hubspot pages
	var bitsBobsData = [{
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'The User Testing Field Guide',
	  image: {
	    alt: 'The User Testing Field Guide',
	    src: _userTestingFieldGuide2x2.default
	  },
	  url: '/resources/free-ebook-user-testing-field-guide',
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null)
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'Getting Started with Design Systems',
	  image: {
	    alt: 'Getting Started with Design Systems',
	    src: _designSystems2x2.default
	  },
	  url: '/ebook-design-systems/',
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null)
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'The Book of Collaboration: Handoff Edition',
	  image: {
	    alt: 'The Book of Collaboration',
	    src: _ebookCollaboration2x2.default
	  },
	  url: '/ebook-collaboration-handoff-edition/',
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null)
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'The Design Thinking Workshop Kit',
	  image: {
	    alt: 'Design Thinking Worskhop',
	    src: _ebook2x2.default
	  },
	  url: '/workshops',
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null)
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'Sketch Pads: Download our free downloadable templates',
	  image: {
	    alt: 'Sketch Pads',
	    src: _sketchPads2x2.default
	  },
	  url: '/sketchpad',
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null)
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: '13 Pure CSS Mobile Devices.css',
	  image: {
	    alt: 'CSS device',
	    src: _css2x2.default
	  },
	  url: 'https://marvelapp.github.io/devices.css/',
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null)
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'One-pager Case Study: Marvel for Deliveroo',
	  image: {
	    alt: 'Marvel for Deliveroo',
	    src: _deliveroo2x2.default
	  },
	  url: _deliveroo2.default,
	  download: true,
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null)
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'One-pager Case Study: Marvel for Monzo',
	  image: {
	    alt: 'Marvel for Monzo',
	    src: _monzo2x2.default
	  },
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null),
	  url: _monzo2.default,
	  download: true
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'One-pager Case Study: Marvel for Yieldr',
	  image: {
	    alt: 'Marvel for Yielder',
	    src: _yieldr2x2.default
	  },
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null),
	  url: _yieldr2.default,
	  download: true
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'One-pager Case Study: Marvel for Buzzfeed',
	  image: {
	    alt: 'Marvel for Buzzfeed',
	    src: _buzzfeed2x2.default
	  },
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null),
	  url: _buzzfeed2.default,
	  download: true
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'One-pager Case Study: Marvel for Cabify',
	  image: {
	    alt: 'Marvel for Cabify',
	    src: _cabify2x2.default
	  },
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null),
	  url: _cabify2.default,
	  download: true
	}, {
	  labelMessage: 'DOWNLOAD',
	  excerpt: 'One-pager Case Study: Marvel for Hudl',
	  image: {
	    alt: 'Marvel for Hudl',
	    src: _hudl2x2.default
	  },
	  url: _hudl2.default,
	  download: true,
	  labelLogo: _react2.default.createElement(_DownloadBlue2.default, null)
	}];
	
	exports.default = bitsBobsData;
	module.exports = exports['default'];

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _layersPanelHandoff = __webpack_require__(2692);
	
	var _layersPanelHandoff2 = _interopRequireDefault(_layersPanelHandoff);
	
	var _freehandMarvelPrototyping = __webpack_require__(2688);
	
	var _freehandMarvelPrototyping2 = _interopRequireDefault(_freehandMarvelPrototyping);
	
	var _userTestsZoom = __webpack_require__(2702);
	
	var _userTestsZoom2 = _interopRequireDefault(_userTestsZoom);
	
	var _launchUserTestsDirectly = __webpack_require__(2691);
	
	var _launchUserTestsDirectly2 = _interopRequireDefault(_launchUserTestsDirectly);
	
	var _organisingWorkflowFolders = __webpack_require__(2694);
	
	var _organisingWorkflowFolders2 = _interopRequireDefault(_organisingWorkflowFolders);
	
	var _foldersOrganiseShareYourProjects = __webpack_require__(2687);
	
	var _foldersOrganiseShareYourProjects2 = _interopRequireDefault(_foldersOrganiseShareYourProjects);
	
	var _createRemoteUsabilityTests = __webpack_require__(2679);
	
	var _createRemoteUsabilityTests2 = _interopRequireDefault(_createRemoteUsabilityTests);
	
	var _pitchUsingPrototypes = __webpack_require__(2695);
	
	var _pitchUsingPrototypes2 = _interopRequireDefault(_pitchUsingPrototypes);
	
	var _usingGoals = __webpack_require__(2703);
	
	var _usingGoals2 = _interopRequireDefault(_usingGoals);
	
	var _sections = __webpack_require__(2698);
	
	var _sections2 = _interopRequireDefault(_sections);
	
	var _howToRunGuerillaUserTests = __webpack_require__(2689);
	
	var _howToRunGuerillaUserTests2 = _interopRequireDefault(_howToRunGuerillaUserTests);
	
	var _designThinkingWorkshop = __webpack_require__(2683);
	
	var _designThinkingWorkshop2 = _interopRequireDefault(_designThinkingWorkshop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productUpdatesData = [{
	  excerpt: 'We’ve just launched a layers panel for Handoff!',
	  image: {
	    alt: 'Layers Panel Handoff',
	    src: _layersPanelHandoff2.default
	  },
	  url: 'https://marvelapp.com/blog/layers-panel-handoff/'
	}, {
	  excerpt: 'Mixed.io + Marvel – Remote collaboration on your prototype designs in real-time',
	  image: {
	    alt: 'Remote collaboration on your prototype designs',
	    src: _freehandMarvelPrototyping2.default
	  },
	  url: 'https://marvelapp.com/blog/mixed-io-marvel-collaborate-prototype-designs-real-time/'
	}, {
	  excerpt: 'How to run remote usability tests using Marvel + Zoom or Google Hangouts',
	  image: {
	    alt: 'Test your application remotely',
	    src: _userTestsZoom2.default
	  },
	  url: 'https://marvelapp.com/blog/run-remote-usability-tests-using-marvel-zoom-google-hangouts/'
	}, {
	  excerpt: 'Launch user tests directly from the Marvel iOS app!',
	  image: {
	    alt: 'Launch User Tests from the Marvel iOS app',
	    src: _launchUserTestsDirectly2.default
	  },
	  url: 'https://marvelapp.com/blog/launch-user-tests-directly-marvel-ios-app/'
	}, {
	  excerpt: 'Organising clients, features, departments and work with folders',
	  image: {
	    alt: 'Organise with Folders',
	    src: _organisingWorkflowFolders2.default
	  },
	  url: 'https://marvelapp.com/blog/organising-workflow-folders/'
	}, {
	  excerpt: 'How to create remote usability tests in Marvel',
	  image: {
	    alt: 'Create Remote Usability Tests',
	    src: _createRemoteUsabilityTests2.default
	  },
	  url: 'https://marvelapp.com/blog/create-remote-usability-tests-marvel/'
	}, {
	  excerpt: 'How to organise and share your projects with folders',
	  image: {
	    alt: 'Organise And Share Your Projects',
	    src: _foldersOrganiseShareYourProjects2.default
	  },
	  url: 'https://marvelapp.com/blog/how-to-organise-share-your-projects-with-folders/'
	}, {
	  excerpt: 'How to pitch and present ideas using prototypes to clients and stakeholders',
	  image: {
	    alt: 'Present Ideas Using Prototypes',
	    src: _pitchUsingPrototypes2.default
	  },
	  url: 'https://marvelapp.com/blog/pitch-present-ideas-using-prototypes-clients-stakeholders/'
	}, {
	  excerpt: 'Using goals to determine your best performing prototype',
	  image: {
	    alt: 'Determine Your Best Performing Prototype',
	    src: _usingGoals2.default
	  },
	  url: 'https://marvelapp.com/blog/using-goals-determine-best-performing-prototype/'
	}, {
	  excerpt: '5 great ways to use sections in your Marvel projects',
	  image: {
	    alt: 'Use Sections in Your Marvel Projects',
	    src: _sections2.default
	  },
	  url: 'https://marvelapp.com/blog/5-great-ways-to-use-sections-in-your-marvel-projects/'
	}, {
	  excerpt: 'How to run guerrilla user testing with Marvel',
	  image: {
	    alt: 'Run Guerrilla User Testing',
	    src: _howToRunGuerillaUserTests2.default
	  },
	  url: 'https://marvelapp.com/blog/how-to-run-guerrilla-user-testing-with-marvel/'
	}, {
	  excerpt: 'How to run your first design thinking workshop using Marvel',
	  image: {
	    alt: 'Run Your First Design Thinking Workshop',
	    src: _designThinkingWorkshop2.default
	  },
	  url: 'https://marvelapp.com/blog/run-first-design-thinking-workshop-prototypes/'
	}];
	exports.default = productUpdatesData;
	module.exports = exports['default'];

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _workshopResources2x = __webpack_require__(2706);
	
	var _workshopResources2x2 = _interopRequireDefault(_workshopResources2x);
	
	var _webinarSantander2x = __webpack_require__(2704);
	
	var _webinarSantander2x2 = _interopRequireDefault(_webinarSantander2x);
	
	var _userTestingWebinar2x = __webpack_require__(2701);
	
	var _userTestingWebinar2x2 = _interopRequireDefault(_userTestingWebinar2x);
	
	var _murat = __webpack_require__(2508);
	
	var _murat2 = _interopRequireDefault(_murat);
	
	var _zorast2x = __webpack_require__(2509);
	
	var _zorast2x2 = _interopRequireDefault(_zorast2x);
	
	var _BobbyChadha2x = __webpack_require__(2506);
	
	var _BobbyChadha2x2 = _interopRequireDefault(_BobbyChadha2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var webinarData = [{
	  avatarOneImage: _murat2.default,
	  labelMessage: 'COMING SOON',
	  excerpt: 'Getting started with User Testing and the all-new Marvel 3',
	  image: {
	    alt: 'UserTesting',
	    src: _userTestingWebinar2x2.default
	  },
	  url: '/resources/webinar-get-started-with-marvel-3'
	}, {
	  avatarOneImage: _BobbyChadha2x2.default,
	  labelMessage: 'ON DEMAND',
	  excerpt: 'Principles of User Testing at Santander',
	  image: {
	    alt: 'Santander',
	    src: _webinarSantander2x2.default
	  },
	  url: '/resources/webinar-marvel-santander-03-2019'
	}, {
	  avatarOneImage: _murat2.default,
	  avatarTwoImage: _zorast2x2.default,
	  labelMessage: 'ON DEMAND',
	  excerpt: 'How to run your first Design Thinking Workshop',
	  image: {
	    alt: 'Design Thinking Workshop',
	    src: _workshopResources2x2.default
	  },
	  url: '/resources/webinar-design-thinking-02-2019'
	}];
	
	exports.default = webinarData;
	module.exports = exports['default'];

/***/ }),

/***/ 1529:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/buzzfeed.05e35164.pdf";

/***/ }),

/***/ 1530:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cabify.669ef82e.pdf";

/***/ }),

/***/ 1531:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/deliveroo.bbc1df66.pdf";

/***/ }),

/***/ 1532:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hudl.d56ba1f1.pdf";

/***/ }),

/***/ 1533:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/monzo.ef4a3eeb.pdf";

/***/ }),

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/yieldr.54c10f88.pdf";

/***/ }),

/***/ 2506:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/BobbyChadha@2x-4a12b74d694135ef717db28bdb21c579.jpg";

/***/ }),

/***/ 2508:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/murat-243fe939ec9c5d294a347f73825cbae3.jpg";

/***/ }),

/***/ 2509:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2677:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/buzzfeed@2x-c58486752fc496ffd8cfd27ac3e94c6d.png";

/***/ }),

/***/ 2678:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cabify@2x-2bd677a47c202d14d9dc4b9b8d5dec5c.png";

/***/ }),

/***/ 2679:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/create-remote-usability-tests-7c488c4fca73693002ab81b7c20fcf43.png";

/***/ }),

/***/ 2680:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/css@2x-aa97de07aab75b912908563e0c1ae8e5.png";

/***/ }),

/***/ 2681:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/deliveroo@2x-2b8f7bf219d0bb591959f35824b17d9a.png";

/***/ }),

/***/ 2682:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/design-systems2x-1a4a685b373fe0082e295d35dbcf8536.png";

/***/ }),

/***/ 2683:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/design-thinking-workshop-a3c6476a89453284912b2bc450ff2594.png";

/***/ }),

/***/ 2684:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ebook-collaboration@2x-616972944d67c87dc498b00c142fae6d.png";

/***/ }),

/***/ 2685:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ebook@2x-311530bedc7ab7d3b576d7cb1a8df1bc.png";

/***/ }),

/***/ 2686:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/events@2x-da2ce02aba8ed9dca8451e3dd7efc459.png";

/***/ }),

/***/ 2687:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/folders-organise-share-your-projects-b53ab42b78f239a6e408e13c0502660a.png";

/***/ }),

/***/ 2688:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/freehand-marvel-prototyping-4e12cf7905a89d29711a6e15644e1f24.png";

/***/ }),

/***/ 2689:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/how-to-run-guerilla-user-tests-c36208e0973bec635b79617145c7d2d9.png";

/***/ }),

/***/ 2690:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hudl@2x-3e0f04c3e89b8352d67afa4b8c732e61.png";

/***/ }),

/***/ 2691:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/launch-user-tests-directly-bcffe4b495e94e256725b026e46b7426.png";

/***/ }),

/***/ 2692:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/layers-panel-handoff-5135bb881c74171d57d21f3ffa6cc976.png";

/***/ }),

/***/ 2693:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/monzo@2x-b27970b3c65c853fa9764fbef899d5ba.png";

/***/ }),

/***/ 2694:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/organising-workflow-folders-99bcd186d445449d7cb5e2ac242fd930.png";

/***/ }),

/***/ 2695:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pitch-using-prototypes-cb4013c37b4f4256bf0b0878a9a13534.png";

/***/ }),

/***/ 2696:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/product-updates@2x-15de89374b05e55baad740cde92e292a.png";

/***/ }),

/***/ 2697:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/resources@2x-4a87a970f6eb8d18ab7517056fcb65e6.png";

/***/ }),

/***/ 2698:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sections-fd2260be635193338eb2cc2051b0f77c.png";

/***/ }),

/***/ 2699:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sketch-pads@2x-f1001b14e3e6ee20688531b35fa581f6.png";

/***/ }),

/***/ 2700:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/user-testing-field-guide@2x-e72aaea3e07863ba09a4c1e5b3121cef.png";

/***/ }),

/***/ 2701:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/user-testing-webinar@2x-4ee2dbc10dc29fbfec63f2924bf05de8.png";

/***/ }),

/***/ 2702:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/user-tests-zoom-2d387328d4877343296c0553417927df.png";

/***/ }),

/***/ 2703:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/using-goals-b3a7b5bb4135f3e01df4cd6949d45110.png";

/***/ }),

/***/ 2704:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/webinar-santander@2x-07a7b08bb22d247ac1389631d06d9caa.png";

/***/ }),

/***/ 2706:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/workshop-resources@2x-d1ced04e2e49842f57d78143c52fa23b.jpg";

/***/ }),

/***/ 2707:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/yieldr@2x-39d7332ee7f16b07a279cb7a6b2b5ae9.png";

/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = BitsAndBobs;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _index = __webpack_require__(611);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _bitsBobsData = __webpack_require__(1244);
	
	var _bitsBobsData2 = _interopRequireDefault(_bitsBobsData);
	
	var _HeadingCopy = __webpack_require__(591);
	
	var _HeadingCopy2 = _interopRequireDefault(_HeadingCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BitsAndBobs() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_HeadingCopy2.default, {
	      title: 'Bits & Bobs',
	      subheading: 'A collection of online guides and downloadable assets, eBooks and customer stories for you to carry with you.'
	    }),
	    _react2.default.createElement(
	      _grid2.default,
	      { columns: 12, justifyContent: 'left' },
	      _bitsBobsData2.default.map(function (item) {
	        return _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 3, columnSpanS: 6 },
	          _react2.default.createElement(_index2.default, _extends({ key: item.name }, item))
	        );
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = HeadingCards;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _assets = __webpack_require__(1243);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _ResourcesCard = __webpack_require__(1294);
	
	var _ResourcesCard2 = _interopRequireDefault(_ResourcesCard);
	
	var _generalModule = __webpack_require__(758);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HeadingCards() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      { className: _generalModule2.default.heading },
	      'Resources Hub'
	    ),
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', type: 'margin', position: 'bottom' },
	      _react2.default.createElement(
	        _maxWidth2.default,
	        { value: 500 },
	        _react2.default.createElement(
	          'h2',
	          { className: _generalModule2.default.subheading },
	          'A library of educational gems that\u2019ll get you up to speed with all things Marvel'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _grid2.default,
	      { columns: 12, size: 'm' },
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 12, columnSpanM: 4 },
	        _react2.default.createElement(_ResourcesCard2.default, {
	          artwork: _assets2.default.events,
	          title: "What's on",
	          excerpt: 'Catch up on the latest from the team, from webinars to events',
	          url: '#webinars'
	        })
	      ),
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 12, columnSpanM: 4 },
	        _react2.default.createElement(_ResourcesCard2.default, {
	          artwork: _assets2.default.product,
	          title: 'Product updates',
	          excerpt: 'All our launches, news and ships in one place',
	          url: '#productupdates'
	        })
	      ),
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 12, columnSpanM: 4 },
	        _react2.default.createElement(_ResourcesCard2.default, {
	          artwork: _assets2.default.guides,
	          title: 'Bits & Bobs',
	          excerpt: 'Our collection of online guides and downloadable assets',
	          url: '#bits+bobs'
	        })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ProductUpdates;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _index = __webpack_require__(611);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _productUpdatesData = __webpack_require__(1245);
	
	var _productUpdatesData2 = _interopRequireDefault(_productUpdatesData);
	
	var _HeadingCopy = __webpack_require__(591);
	
	var _HeadingCopy2 = _interopRequireDefault(_HeadingCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProductUpdates() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_HeadingCopy2.default, {
	      title: 'Product Updates',
	      subheading: 'Keep up with all our product launches, small ships and news'
	    }),
	    _react2.default.createElement(
	      _grid2.default,
	      { columns: 12, size: 'm' },
	      _productUpdatesData2.default.map(function (item) {
	        return _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 3, columnSpanS: 6 },
	          _react2.default.createElement(_index2.default, _extends({ key: item.name }, item))
	        );
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _Card = __webpack_require__(76);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _generalModule = __webpack_require__(758);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourcesCard = function (_Component) {
	  _inherits(ResourcesCard, _Component);
	
	  function ResourcesCard() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResourcesCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isHovered: false
	    }, _this.toggleIsHovered = function () {
	      _this.setState({ isHovered: !_this.state.isHovered });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ResourcesCard.prototype.render = function render() {
	    var _props = this.props,
	        excerpt = _props.excerpt,
	        title = _props.title,
	        url = _props.url,
	        artwork = _props.artwork;
	
	    return _react2.default.createElement(
	      _link2.default,
	      { url: url, block: true },
	      _react2.default.createElement(
	        'div',
	        {
	          onMouseOver: this.toggleIsHovered,
	          onMouseOut: this.toggleIsHovered,
	          className: _generalModule2.default.spacing
	        },
	        _react2.default.createElement(
	          _Card2.default,
	          {
	            size: 'mediumLarge',
	            withBorder: true,
	            withBorderRadius: false,
	            withMargin: false,
	            withShadow: this.state.isHovered
	          },
	          _react2.default.createElement(_Image2.default, _extends({}, artwork, { maxWidth: 250, hasShadow: false })),
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 250 },
	            _react2.default.createElement(
	              _spacing2.default,
	              { type: 'padding', position: 'topBottom', size: 's' },
	              _react2.default.createElement(
	                _spacing2.default,
	                { type: 'padding', position: 'bottom', size: 'xs' },
	                _react2.default.createElement(
	                  _heading2.default,
	                  { weight: 'semibold', size: 'xl' },
	                  title
	                )
	              ),
	              _react2.default.createElement(
	                _paragraph2.default,
	                { size: 'm', color: 'slate' },
	                excerpt
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ResourcesCard;
	}(_react.Component);
	
	exports.default = ResourcesCard;
	
	
	ResourcesCard.propTypes = {
	  artwork: _propTypes2.default.object,
	  excerpt: _customPropTypesCheck2.default,
	  title: _customPropTypesCheck2.default,
	  url: _customPropTypesCheck2.default
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = WebinarsBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _webinarData = __webpack_require__(1246);
	
	var _webinarData2 = _interopRequireDefault(_webinarData);
	
	var _index = __webpack_require__(611);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _HeadingCopy = __webpack_require__(591);
	
	var _HeadingCopy2 = _interopRequireDefault(_HeadingCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WebinarsBlock() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_HeadingCopy2.default, {
	      title: 'What\'s on',
	      subheading: 'Catch up on our latest webinars and keep an eye out for upcoming events for you to join'
	    }),
	    _react2.default.createElement(
	      _grid2.default,
	      { columns: 12 },
	      _webinarData2.default.map(function (item) {
	        return _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 12, columnSpanM: 3, columnSpanS: 6 },
	          _react2.default.createElement(_index2.default, _extends({ key: item.name }, item))
	        );
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ResourceLanding;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _WebinarsBlock = __webpack_require__(1295);
	
	var _WebinarsBlock2 = _interopRequireDefault(_WebinarsBlock);
	
	var _BitsAndBobs = __webpack_require__(1291);
	
	var _BitsAndBobs2 = _interopRequireDefault(_BitsAndBobs);
	
	var _ProductUpdates = __webpack_require__(1293);
	
	var _ProductUpdates2 = _interopRequireDefault(_ProductUpdates);
	
	var _HeadingCards = __webpack_require__(1292);
	
	var _HeadingCards2 = _interopRequireDefault(_HeadingCards);
	
	var _generalModule = __webpack_require__(758);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ResourceLanding() {
	  var homepage = _metadata2.default.resources.homepage;
	
	  var pageProps = {
	    title: homepage.title,
	    meta: [{
	      name: 'description',
	      content: homepage.description
	    }],
	    header: {
	      title: 'Resources',
	      isResources: true
	    },
	    footer: true,
	    banner: false
	  };
	  return _react2.default.createElement(
	    _Page2.default,
	    pageProps,
	    _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.wrap },
	      _react2.default.createElement(_HeadingCards2.default, null),
	      _react2.default.createElement('a', { name: 'webinars' }),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'padding', position: 'top', size: 'l' },
	        _react2.default.createElement(_WebinarsBlock2.default, null)
	      ),
	      _react2.default.createElement('a', { name: 'productupdates' }),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'padding', position: 'top', size: 'l' },
	        _react2.default.createElement(_ProductUpdates2.default, null)
	      ),
	      _react2.default.createElement('a', { name: 'bits+bobs' }),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'padding', position: 'top', size: 'l' },
	        _react2.default.createElement(_BitsAndBobs2.default, null)
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrap":"src-pages-resources-styles----general-module---wrap---1GWll pageWrap c-black textAlign-center pageWrap-l","subheading":"src-pages-resources-styles----general-module---subheading---3g7WC breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xxl fontWeight-4 c-slate","heading":"src-pages-resources-styles----general-module---heading---2XeGj fontWeight-5 marginBottom-m fontSize-xxxl breakPointS-fontSize-xxxxl","spacing":"src-pages-resources-styles----general-module---spacing---3ax55"};

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function TrackHover(Component) {
	  return function (_React$Component) {
	    _inherits(Hoverable, _React$Component);
	
	    function Hoverable() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Hoverable);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	        isHovered: false
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Hoverable.prototype.setIsHovered = function setIsHovered(isHovered) {
	      this.setState({
	        isHovered: isHovered
	      });
	    };
	
	    Hoverable.prototype.render = function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseOver: function onMouseOver() {
	            return _this2.setIsHovered(true);
	          },
	          onMouseOut: function onMouseOut() {
	            return _this2.setIsHovered(false);
	          }
	        },
	        _react2.default.createElement(Component, _extends({}, this.props, { isHovered: this.state.isHovered }))
	      );
	    };
	
	    return Hoverable;
	  }(_react2.default.Component);
	}
	
	exports.default = TrackHover;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resources-index-js-c31dacabc1e64cf6d2f8.js